import { useEffect } from "react";

// نبضة الحضور: تُخبر الخادم أنّ المستخدم ما زال هنا، فيُشتقّ «متصل/آخر ظهور»
// من وقتٍ حقيقيّ لا من علمٍ مخزَّن. بدونها يبقى `last_seen_at` فارغاً وعمود
// «آخر ظهور» بلا قيمة — وهي العلّة التي جعلته لا يعرض شيئاً أبداً.
//
// تتوقّف حين تُخفى النافذة: من ترك التبويب مفتوحاً على جهازٍ نائم ليس حاضراً،
// وإبقاء النبضة تجعله «متصلاً» أبداً — أي العلّة نفسها بثوبٍ آخر.
const INTERVAL_MS = 60_000;

export function useHeartbeat(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) return undefined;
    let stopped = false;

    const beat = () => {
      if (stopped || document.visibilityState !== "visible") return;
      const token = localStorage.getItem("waslacrm_token");
      if (!token) return;
      void fetch("/api/agents/me/heartbeat", {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => { /* النبضة ليست حرجة */ });
    };

    beat(); // فوراً عند الدخول، فلا ينتظر العضوُ دقيقةً ليظهر متصلاً
    const timer = window.setInterval(beat, INTERVAL_MS);
    // العودة إلى التبويب تُعلن الحضور فوراً بدل انتظار الدورة التالية.
    document.addEventListener("visibilitychange", beat);
    return () => {
      stopped = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", beat);
    };
  }, [enabled]);
}
